import { createReducer } from '@reduxjs/toolkit';

import { TYPES } from '../../common/constants';

const fetchPropertyDevelopers = (_,{ payload }) => {
    return payload
}

const updatePropertyDeveloper = ( propertyDevelopers, { payload }) => {
    return null
}

const deletePropertyDeveloper = ( propertyDevelopers, { payload }) => {
    return propertyDevelopers.filter( data => data.id !== payload.id)
}

const initialState = [];

export default createReducer(initialState,{
    [TYPES.FETCH_PROPERTY_DEVELOPERS_DONE]:fetchPropertyDevelopers,
    [TYPES.UPDATE_PROPERTY_DEVELOPERS_DONE]:updatePropertyDeveloper,
    [TYPES.DELETE_PROPERTY_DEVELOPERS_DONE]:deletePropertyDeveloper
})
